import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GROUP_BY_UUID_RESOURCE } from "../group/use-group-by-uuid.query";
import { USER_APP_ROLE_RESOURCE } from "../user/use-user-app-role.query";

export const RULE_RESTORE_RESOURCE = "rule" as const;
export const RULE_RESTORE_API_PATH = `/v1/${RULE_RESTORE_RESOURCE}/{uuid}/restore` as const;

export type RuleRestoreResponse =
  paths[typeof RULE_RESTORE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useRuleRestoreMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<RuleRestoreResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<RuleRestoreResponse>(
        `/v1/${RULE_RESTORE_RESOURCE}/${uuid}/restore`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [RULE_RESTORE_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [GROUP_BY_UUID_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [USER_APP_ROLE_RESOURCE],
        }),
      ]);
    },
  });
};
